import { Identity } from './User'

export interface CrossClientQueryAtomicClause {
  variable: string
  description: string
  questionForm: string
}

export interface CrossClientQueryLogicalQuestionDecomposition {
  explanation: string
  logicalFormula: string
  atomicClauses: CrossClientQueryAtomicClause[]
}

export const CrossClientQueryPhases = {
  NO_CLIENTS_WERE_FOUND: 'noClientsWereFound',
  NO_CLIENTS_AFTER_FILTER_IDS: 'noClientsAfterFilterIDs',
  NO_CLIENTS_AFTER_FILTER_ROLE: 'noClientsAfterFilterRole',
  QUESTION_ERROR: 'questionError',
  INITIALIZED: 'initialized',
  READY: 'ready',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  ERRORED: 'errored',
} as const

export type CrossClientQueryPhase = (typeof CrossClientQueryPhases)[keyof typeof CrossClientQueryPhases]

export const CrossClientQueryResultStatuses = {
  INITIALIZED: 'initialized',
  PROCESSING: 'processing',
  SUCCEEDED: 'succeeded',
  NO_DATA: 'noData',
  FAILED: 'failed',
} as const

export type CrossClientQueryResultStatus = (typeof CrossClientQueryResultStatuses)[keyof typeof CrossClientQueryResultStatuses]

export const CrossClientQueryResultMatches = {
  MATCH: 'Match',
  NO_MATCH: 'No match',
} as const

export type CrossClientQueryResultMatch = (typeof CrossClientQueryResultMatches)[keyof typeof CrossClientQueryResultMatches]

export interface CrossClientQueryExecution {
  id: string
  createdAt: string
  updatedAt: string
  createdBy: Identity
  updatedBy: Identity
  phase: CrossClientQueryPhase
  clientIds: string[]
  decomposition?: CrossClientQueryLogicalQuestionDecomposition
  userQuestion: string
}

export interface CrossClientQueryInitializedExecution {
  executionId: string
  phase: CrossClientQueryPhase
  decomposition?: CrossClientQueryLogicalQuestionDecomposition
}

export interface CrossClientQueryResultSources {
  scorecardResultIds: string[]
}

export type CrossClientQueryDecision = boolean | null

export interface CrossClientQueryResultAnswer {
  decision: CrossClientQueryDecision
  explanation: string
}

export interface CrossClientQueryResult {
  id: string
  clientId: string
  status: CrossClientQueryResultStatus
  createdAt: string
  updatedAt: string
  sources?: CrossClientQueryResultSources
  answers?: CrossClientQueryResultAnswer[]
}

export interface CrossClientQueryResultDisplay extends CrossClientQueryResult {
  match: CrossClientQueryResultMatch
}

export interface CrossClientQueryExecutionProgressResponse {
  executionId: string
  phase: CrossClientQueryPhase
  status: CrossClientQueryResultStatus
  createdAt: string
  lastUpdatedAt: string
  resultIds: string[]
}

export interface CrossClientQueryExecutionProgress {
  executionId: string
  phase: CrossClientQueryPhase
  statuses: Record<CrossClientQueryResultStatus, number>
  lastUpdatedAt: string
}
